import { Injectable } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(
    private translocoService: TranslocoService,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController
  ) {}

  async getLoadingCtrl(message: string): Promise<HTMLIonLoadingElement> {
    const loadingEl = await this.loadingCtrl.create({
      message: this.translocoService.translate(message),
    });

    return loadingEl;
  }

  async showAlert(
    header: string,
    message: string,
    translate: boolean,
    buttons?: any
  ) {
    const alert = await this.alertCtrl.create({
      backdropDismiss: false,
      header: this.translocoService.translate(header),
      message: translate ? this.translocoService.translate(message) : message,
      buttons,
    });

    await alert.present();
  }

  async showGoBackAlert(confirmHandler) {
    const alert = await this.alertCtrl.create({
      header: this.translocoService.translate('goBackHeader'),
      message: this.translocoService.translate('goBackMessage'),
      buttons: [
        {
          text: this.translocoService.translate('confirm'),
          handler: confirmHandler,
        },
        {
          text: this.translocoService.translate('cancel'),
          cssClass: 'secondary',
        },
      ],
    });

    await alert.present();
  }

  async showConfirmAlert(confirmHandler, cancelHandler) {
    const alert = await this.alertCtrl.create({
      header: this.translocoService.translate('updateFields'),
      message: this.translocoService.translate('updateFieldsMessage'),
      buttons: [
        {
          text: this.translocoService.translate('confirm'),
          handler: confirmHandler,
        },
        {
          text: this.translocoService.translate('cancel'),
          cssClass: 'secondary',
          handler: cancelHandler,
        },
      ],
    });

    await alert.present();
  }

  async presentAlert(pageType: string, options: any[]) {
    let body = '';

    options.forEach((item) => {
      const value = `${pageType}.${item.value}`;

      body += `<div class='territory-item'>
        <span class='territory-color-box ${item.value}'></span>
        <span class='territory-value' style="color: green;">${this.translocoService.translate(
          value
        )}</span>
      </div>`;
    });

    const alert = await this.alertCtrl.create({
      message: `<div class='legend-items'>${body}</div>`,
      buttons: [{ text: this.translocoService.translate('close') }],
    });
    await alert.present();
  }
}
